<template>
  <section
    class="section-block"
    :class="{ 'section-block--with-border': withBorder }"
  >
    <div class="section-block__content">
      <h2 v-if="title" class="section-block__title">{{ title }}</h2>
      <h3 v-if="subTitle" class="section-block__sub-title">{{ subTitle }}</h3>
      <div class="section-block__slot">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionBlock",
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    withBorder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.section-block {
  padding: 40px 0 60px;

  @include respond-above(md) {
    padding: 60px 0 80px;
  }

  &--with-border {
    border-bottom: 1px solid $color-grey-light;
  }

  &__content {
    @extend .container;
    margin: 0 auto;
    text-align: center;
  }

  &__title {
    @include editorial-headline(24px);
    text-transform: uppercase;
    margin-bottom: 10px;
    line-height: 130%;
    text-align: center;

    @include respond-above(md) {
      margin-bottom: 20px;
    }
  }

  &__sub-title {
    @include editorial-body(14px);
    line-height: 150%;
    margin-bottom: 20px;
    text-align: center;
    max-width: 440px;
    text-wrap: balance;
    margin: 0 auto;

    @include respond-above(md) {
      margin-bottom: 30px;
    }
  }

  &__slot {
    margin-top: 40px;

    @include respond-above(md) {
      margin-top: 60px;
    }
  }
}

.section-block__slot > :slotted(*:not(:first-child)) {
  margin-top: 40px;

  @include respond-above(md) {
    margin-top: 60px;
  }
}
</style>
